// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__CboMS","title":"Info_title__xrapT","selects":"Info_selects__AKq9t","requiredAsterisk":"Info_requiredAsterisk__3a_As"};